import styled from 'styled-components'

import Modal from '../Modal'
import AdsAlertForm from '../../forms/AdsAlertForm'
import { Wrapper } from '../Modal/styled'

export const ModalStyled = styled(Modal)`
  ${Wrapper} {
    max-width: 70rem;
    width: 100%;
  }
`
export const Form = styled(AdsAlertForm)`
  margin-top: 2.4rem;
`
